const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { MomentOwned } from './MomentOwned';
import * as telegram from "./telegram"
import * as utils_time from "./utils_time"
import * as utils_topshot from "./utils_topshot"
import { Account } from './Account';

export type sortOrderTypes = 'FMV_DESC' | 'FMV_ASC' | 'AcquiredPrice_DESC' | 'AcquiredPrice_ASC' | 'AcquiredDate_DESC' | 'AcquiredDate_ASC'  | 'ListedPrice_DESC' | 'ListedPrice_ASC' | 'ListedDate_DESC' | 'ListedDate_ASC' | 'Movement_DESC' | 'Movement_ASC' | 'Gain_ASC' | 'Gain_DESC'

export class MomentListed extends MomentOwned {
  public listedDate: Date = null
  public listedPrice: number = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super(po)
    if (po) this.injectPlainObject(po)

    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (typeof this.listedDate === 'string') this.listedDate = new Date(this.listedDate)
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    return true
  }

  public getNiceDiffString(): string {
    const numericalGain: number = this.valueFMV - this.listedPrice
    const nice: string = `${ numericalGain < 0 ? '+' : '-'}${utils_topshot.getNicePriceString(Math.abs(numericalGain))}`
    return nice
  }
  public getDiffClass(): string {
    if (this.valueFMV >= this.listedPrice) return 'positive'
    return 'negative'
  }
  public getNiceMarketTimeString(): string {
    if (!this.listedDate) return ''
    const timeDiff: number = new Date().getTime() - this.listedDate.getTime()
    return `Unsold for ${utils_time.shortTimeDiff(timeDiff)}`
  }
}

(async () => {
})();
